export default "__VITE_ASSET__RwczWl4G__"